import { atom, selector } from "recoil";
import { getClasses } from "../../network/Endpoint";
import {teacherIdState} from "../teacher/teacherIdState";
import {recoilPersist} from "recoil-persist";


const {persistAtom} = recoilPersist({
    key: "classPersist",
    storage:sessionStorage, //sessionStorage사용
})

// 2️⃣ `classes` 데이터를 저장하는 atom
export const classesState = atom({
    key: "classesState",
    default: null,
});

// 3️⃣ `savedClasses` 원본 데이터를 저장하는 atom
export const savedClassesState = atom({
    key: "savedClassesState",
    default: null,
});

export const mainClassState = atom ({
    key: "mainClassState",
    default: null,
    effects_UNSTABLE: [persistAtom]
});

// 4️⃣ 비동기 API 요청을 수행하는 selector
export const fetchClassesSelector = selector({
    key: "fetchClassesSelector",
    get: async ({ get }) => {
        get(fetchTriggerState); // ✅ 트리거 의존성 추가
        const teacherId = get(teacherIdState);
        if (!teacherId) return null;
        try {
            const res = await getClasses({ teacherId });
            if (res.data.status.code === "Success") {
                return res.data.data; // API에서 받은 데이터 반환
            } else {
                throw new Error("데이터 가져오기 실패");
            }
        } catch (error) {
            console.error("API 요청 오류:", error);
            return null;
        }
    },
});

export const fetchTriggerState = atom({
    key: "fetchTriggerState",
    default: 0,
});
